<template>
    <div>
        <multiselect
            v-model="value"
            :options="options"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :preserve-search="true"
            :multiple="true"
            v-bind:placeholder="placeholder"
            v-bind:label="label"
            v-bind:track-by="trackby"
            v-bind:id="id"
        >
        </multiselect>
        <input type="hidden" v-for="option in value" v-bind:name="name" v-bind:value="option[trackby]">
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    export default {
        components: {
            Multiselect
        },
        props: [
            'value',
            'options',
            'placeholder',
            'label',
            'trackby',
            'id',
            'name',
        ],
    }
</script>
